import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CoinIcon, TrashIcon, ChevronDownIcon } from '../../../model/icons';
import { teamColor } from './fairModel';

// Строка команды ярмарки (.fr-team): баланс, пополнение/снятие, удаление, раскрытие истории.
export default function TeamRow({ team, onAddBalance, onDelete, expanded, onToggleHistory }) {
    const [amount, setAmount] = useState('');

    const add = () => {
        if (!amount || Number(amount) === 0) return;
        onAddBalance(team.id, Number(amount));
        setAmount('');
    };

    return (
        <div className="fr-team">
            <div className="nm">
                <span className="bdot" style={{ background: team.color || teamColor(team.id) }} />
                {team.teamName}
                {team.isSystem && <span className="fr-systag">система</span>}
                {team.subsidyUsageCount > 0 && <span className="fr-subchip">субсидий: {team.subsidyUsageCount}</span>}
            </div>
            <div className="fr-bal">{team.balance} <CoinIcon /></div>
            <div className="fr-adj">
                <input className="input" type="number" placeholder="+/−" value={amount} onChange={(e) => setAmount(e.target.value)} />
                <button type="button" className="btn btn-primary btn-sm" onClick={add} disabled={!amount}>Добавить</button>
                <button type="button" className="fr-del" onClick={() => onDelete(team)} title="Убрать команду с ярмарки"><TrashIcon /></button>
            </div>
            {onToggleHistory && (
                <button type="button" className={`fr-thist${expanded ? ' open' : ''}`} onClick={onToggleHistory} title="История покупок"><ChevronDownIcon /></button>
            )}
        </div>
    );
}

TeamRow.propTypes = {
    team: PropTypes.shape({
        id: PropTypes.number.isRequired,
        teamName: PropTypes.string,
        color: PropTypes.string,
        balance: PropTypes.number,
        isSystem: PropTypes.bool,
        subsidyUsageCount: PropTypes.number
    }).isRequired,
    onAddBalance: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    expanded: PropTypes.bool,
    onToggleHistory: PropTypes.func
};

TeamRow.defaultProps = { expanded: false, onToggleHistory: null };
